import React, { useState, useEffect } from "react";
import { Card, Typography, Button, Form, message, Divider } from "antd";
import GeneralInfo from "./GeneralInfo.tsx";
import { EditOutlined, CloseCircleOutlined, CheckCircleFilled } from "@ant-design/icons";
import { useForm } from "react-hook-form";

import { propertyService } from "../../../../../configs/constants";

import axios from "../../../../../utils/axiosInceptor";
import { useDispatch } from "react-redux";
import { getConfigData, getPropertyBeneficiaries } from "../../ducks/actions";
import ContractInfo from "../../AddProperty/components/AddInformation/ContractInfo";
import BankAccountInfo from "../../AddProperty/components/AddInformation/BankAccountInfo";
import { useSelector } from "react-redux";
import { getOrgByID } from "../../../Maintenance/Tickets/ducks/actions";
import { filterArray } from "../../../../../utils/filterdata";

var _ = require("lodash");

const { Title } = Typography;

export default ({ propertyDetails, parentId, updateApi }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
    getValues,
  } = useForm();

  const [noEdit, setNoEdit] = useState(true);
  const [block, setBlock] = useState(false);
  const [bankList, setBankList] = useState([]);

  const dispatch: any = useDispatch();
  const configKeys = ["usageTypesList", "locationlist", "emiratesList", "nationalityList", "bankList"];
  const [benificiaryInitial, setBenificiaryInitail] = useState(null);
  const [bankNameInitial, setBankNameInitial] = useState(null);
  const [ownerInitial, setOwnerInitail] = useState(null);
  const configData = useSelector((state: any) => state.dashboard.configData);

  const [properyBeneficieries, setPropertyBeneficieries] = useState([]);
  const organization = useSelector((state: any) => state.tickets.orgData);

  const onSubmit = async (val) => {
    let approvedAnnualRentTypeCasting = val?.approvedAnnualRent ? parseFloat(val?.approvedAnnualRent) : 0;
    const {
      areaSqft,
      unitNumber,
      unitSubType,
      block,
      blockreason,
      unitCode,
      usagesType,
      unitType,
      suiteSize,
      balconySize,
      referralapprovalcode,
      internalSqft,
      externalSqft,
      spaceDescription,
      DMNumber,
      effectiveStartDate,
      effectiveEndDate,
      floorNumber,
    } = val;
    const postJson = {
      unit: {
        ...propertyDetails?.unit,
        areaSqft: areaSqft,
        unitNumber: unitNumber,
        unitSubType: unitSubType.value,
        floorNumber: floorNumber,
        unitCode: unitCode,
        usagesType: usagesType.value,
        unitType: unitType.value,
        suiteSize: suiteSize,
        balconySize: balconySize,
        referralapprovalcode: referralapprovalcode,
      },
      approvedAnnualRent: approvedAnnualRentTypeCasting,
      // after story 9783 adding these fields
      owner: {
        name: ownerInitial?.value,
        nationality: val?.ownerNationality?.value,
        ownerId: ownerInitial?.ownerId,
        number: val?.ownerNumber,
        // email: val?.lessorEmail,
        // phone: val?.lessorPhone,
        // address: val?.lessorAddress,
      },
      beneficiary: benificiaryInitial?.value
        ? {
            beneficiaryId: benificiaryInitial?.value,
            beneficiaryName: benificiaryInitial?.label,
            beneficiaryAccountNumber: val?.accountNo,
            beneficiaryBank: bankNameInitial?.label,
            beneficiaryIBAN: val?.iban,
          }
        : {},
      dewaPremiseNumber: DMNumber,
      erpActiveStartDate: effectiveStartDate,
      erpActiveEndDate: effectiveEndDate,
      description: spaceDescription,
    };

    let postBlockJson = {};

    let url = `${propertyService}/unit/${propertyDetails.unitId}`;
    let blockUrl = `${propertyService}/unit/blockunit`;

    if (block) {
      postBlockJson = {
        unitId: propertyDetails.unitId,
        reason: blockreason,
      };
      await axios.post(blockUrl, postBlockJson);
    } else if (propertyDetails?.blockData) {
      postBlockJson = {
        unitId: propertyDetails.unitId,
        reason: blockreason,
        blockStatus: "unblock",
      };
      await axios.post(blockUrl, postBlockJson);
    }

    await axios
      .patch(url, postJson)
      .then((response) => {
        message.success(response.data.message);
        setNoEdit(true);
        updateApi();
      })
      .catch((error) => {
        message.error(error.response.data.error);
        setNoEdit(true);
        updateApi();
      });
  };

  useEffect(() => {
    const isOrgEmpty = !organization || (typeof organization === "object" && Object.keys(organization).length === 0);

    if (isOrgEmpty) {
      const orgData = localStorage?.getItem("login-response");
      const orgId = orgData ? JSON.parse(orgData) : null;
      if (orgId) dispatch(getOrgByID(orgId?.orgId));
    }

    dispatch(getConfigData(configKeys.join(",")));
  }, []);

  useEffect(() => {
    if (configData && configData?.bankList && Object.keys(configData?.bankList)?.length > 0) {
      const bankList = configData?.bankList || {};
      const formattedBankList = Object?.entries(bankList as Record<string, string>).map(([key, label]) => ({
        label,
        value: label.toLowerCase().replace(/\s+/g, "_"),
      }));
      setBankList(formattedBankList);
    }
  }, [configData?.bankList]);

  function removeCountryCode(phoneNumber) {
    if (phoneNumber && phoneNumber.startsWith("971-")) {
      return phoneNumber.slice(4); // Remove the first 4 characters (971-)
    }
    return phoneNumber;
  }

  useEffect(() => {
    if (Object.keys(propertyDetails).length > 0 && propertyDetails?.unit) {
      const unit = propertyDetails?.unit;

      setValue("unitNumber", unit.unitNumber);
      setValue("areaSqft", unit.areaSqft);
      setValue("blockreason", unit.blockreason);
      setValue("unitSubType", {
        label: unit.unitSubType,
        value: unit.unitSubType,
      });
      setValue("approvedAnnualRent", propertyDetails?.approvedAnnualRent);
      if (propertyDetails?.blockData?.block) {
        setBlock(true);
        setValue("block", true);
        setValue("blockreason", propertyDetails?.blockData?.reason);
      }
      if (propertyDetails?.beneficiaryData) {
        setBankNameInitial({
          value: propertyDetails?.beneficiaryData?.beneficiaryBank,
          label: propertyDetails?.beneficiaryData?.beneficiaryBank,
        });

        propertyDetails?.beneficiaryData &&
          setBenificiaryInitail({
            value: propertyDetails?.beneficiaryData?.beneficiaryId,
            label: propertyDetails?.beneficiaryData?.beneficiaryName,
          });
        propertyDetails?.beneficiaryData?.beneficiaryAccountNumber &&
          setValue("accountNo", propertyDetails?.beneficiaryData?.beneficiaryAccountNumber);
        propertyDetails?.beneficiaryData?.beneficiaryIBAN &&
          setValue("iban", propertyDetails?.beneficiaryData?.beneficiaryIBAN);
      }
      if (propertyDetails?.ownerData) {
        setValue("lessorAddress", propertyDetails?.ownerData?.address);
        setValue("ownerNumber", propertyDetails?.ownerData?.number);
        setValue("lessorEmail", propertyDetails?.ownerData?.email);
        setValue("lessorPhone", removeCountryCode(propertyDetails?.ownerData?.phone), { shouldValidate: true });
      }

      // 🧍‍♂️ Owner setup
      setOwnerInitail({
        value: propertyDetails?.ownerData?.name,
        label: propertyDetails?.ownerData?.name,
        ownerNumber: propertyDetails?.ownerData?.ownerNumber,
        ownerNationality: propertyDetails?.ownerData?.nationality,
        ownerId: propertyDetails?.ownerData?.ownerId,
      });
      if (propertyDetails?.ownerData?.nationality) {
        setValue("ownerNationality", {
          value: propertyDetails?.ownerData?.nationality,
          label: propertyDetails?.ownerData?.nationality,
        });
      }
    }

    return () => {
      setBlock(false);
      setValue("block", false);
      setValue("blockreason", null);
    };
  }, [propertyDetails]);

  return (
    <Form layout="vertical" className="bf-main" name="bookingform" onFinish={handleSubmit(onSubmit)}>
      <Card
        bordered={false}
        bodyStyle={{ padding: "16px 32px 0" }}
        headStyle={{ padding: "16px 32px 0", borderBottom: 0 }}
        title={
          <Title level={5} className="ag-primary mb-0">
            General Information
          </Title>
        }
        extra={[
          <Button
            key={1}
            type="link"
            className={`p-0 no-border no-shadow ${noEdit && "d-none"}`}
            icon={<CloseCircleOutlined />}
            onClick={() => setNoEdit(true)}
            htmlType="button"
          >
            Cancel
          </Button>,
          <Button
            key={2}
            type="link"
            className={`p-0 no-border no-shadow ${noEdit && "d-none"}`}
            icon={<CheckCircleFilled />}
            htmlType="submit"
          >
            Save
          </Button>,
          <Button
            key={3}
            type="link"
            className={`p-0 no-border no-shadow ${!noEdit && "d-none"}`}
            icon={<EditOutlined />}
            onClick={() => setNoEdit(false)}
            htmlType="button"
          />,
        ]}
      >
        <GeneralInfo
          control={control}
          setValue={setValue}
          errors={errors}
          propertyDetails={propertyDetails}
          parentId={parentId}
          updateApi={updateApi}
          noEdit={noEdit}
          watch={watch}
          getValues={getValues}
        />
      </Card>

      <Divider className="m-0" />

      {/* <Card
        bordered={false}
        bodyStyle={{ padding: "16px 32px 0" }}
        headStyle={{ padding: "16px 32px 0", borderBottom: 0 }}
        title={
          <Title level={5} className="ag-primary mb-0">
            Owner Information
          </Title>
        }
      >
        <ContractInfo
          control={control}
          errors={errors}
          propertyId={propertyDetails.propertyId}
          noEdit={noEdit}
          setValue={setValue}
          isUnit={true}
          beneficiaryUrl={`${propertyService}/unit/${propertyDetails.unitId}`}
        />
      </Card> */}

      <Divider className="m-0" />

      <Card
        bordered={false}
        bodyStyle={{ padding: "16px 32px 0" }}
        headStyle={{ padding: "16px 32px 0", borderBottom: 0 }}
        title={
          <Title level={5} className="ag-primary mb-0">
            Owner and Bank Account Information
          </Title>
        }
      >
        <BankAccountInfo
          control={control}
          setBenificiaryInitail={setBenificiaryInitail}
          benificiaryInitial={benificiaryInitial}
          setBankNameInitial={setBankNameInitial}
          ownerInitial={ownerInitial}
          bankNameInitial={bankNameInitial}
          propertyBeneficieries={properyBeneficieries}
          propertyId={propertyDetails.propertyId}
          setOwnerInitail={setOwnerInitail}
          errors={errors}
          setValue={setValue}
          noEdit={noEdit}
          isUnit={true}
          bankList={bankList}
          beneficiaryUrl={`${propertyService}/unit/${propertyDetails.unitId}`}
        />
      </Card>
    </Form>
  );
};
